import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';

export const TranslatedText = ({ textKey }) => {
  const { language } = useLanguage();
  
  if (!textKey) return null;
  
  return translations[language][textKey] || textKey;
};